import Tooltip from '../common/Tooltip'
import { noteTexts, TOOLTIP_WIDTH } from '../../helpers/notes/notePreview'

/**
 * De inhoud van een notitie in een tabelcel: kort in de rij, volledig in een
 * tooltip bij hover. Zonder die tooltip is een lange notitie alleen te lezen
 * door hem te openen.
 *
 * Gedeeld door de vijf notitie-overzichten, zodat ze niet uiteenlopen.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * De tooltip is muis-only en `src/pages/mobile/` rendert deze tabellen ook, dus
 * hij mag niet de enige weg zijn. Bij vier van de vijf overzichten opent de
 * titel van de rij de hele notitie. De vijfde, `ContactMoments.jsx`, heeft
 * helemaal geen open-actie — daar is een lange notitie op een telefoon dus niet
 * te lezen. Zie inbox #138.
 * AI-CONTEXT: See docs/pitfalls.md#ui-hover-only-affordance-dies-on-mobile
 *
 * @param {object} props
 * @param {string} [props.body] - Inhoud van de notitie, HTML of platte tekst
 */
const NoteBodyCell = ({ body }) => {
    const { preview, full } = noteTexts(body)

    // Een lege tooltip is een leeg zwart blokje bij hover; die hoort er dan
    // niet te zijn. Hetzelfde geldt als de hele notitie al in de cel past.
    if (!full || full === preview) return <p className='table-body-preview'>{preview}</p>

    return (
        <Tooltip content={full} maxWidth={TOOLTIP_WIDTH}>
            <p className='table-body-preview'>{preview}</p>
        </Tooltip>
    )
}

export default NoteBodyCell
